import { makeStyles } from "tss-react/mui"
import { TextField } from "@mui/material"
import React from "react"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useDebouncedInput } from "../../../../../../shared/hooks/useDebouncedInput"

const useStyles = makeStyles()(() => ({
    textInput: {
        width: "15rem",
    },
}))

export function EmailSubjectInput({ value, onChange }: { value: string; onChange: (value: string) => void }) {
    const { classes } = useStyles()
    const { innerValue, setInnerValue } = useDebouncedInput(value, onChange)

    return (
        <LocalizedStrict id="support-messages-email-subject-label" attrs={{ label: true }}>
            <TextField
                className={classes.textInput}
                name="emailSubject"
                value={innerValue}
                label="Email Subject"
                onChange={(e) => setInnerValue(e.target.value)}
            />
        </LocalizedStrict>
    )
}
